module.exports = __webpack_public_path__ + "img/gallery-image-38.8bf7e31c.jpg";